import { getMonthlyRevenue } from './tierPricing';
export { getMonthlyRevenue };

/**
 * Calculate commission amount for an affiliate
 */
export function calculateCommission(affiliate, monthlyRevenue) {
  if (affiliate.commission_model === 'fixed') {
    return parseFloat(affiliate.commission_rate) || 0;
  } else {
    // Percentage model - commission_rate is stored as decimal (e.g., 0.10 for 10%)
    const rate = parseFloat(affiliate.commission_rate) || 0;
    return monthlyRevenue * rate;
  }
}

/**
 * Format currency
 */
export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}

/**
 * Format date
 */
export function formatDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

/**
 * Get month label from period_month (e.g., '2026-01-01' -> 'January 2026')
 */
export function getMonthLabel(periodMonth) {
  const date = new Date(periodMonth + 'T00:00:00');
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

/**
 * Get current period month (first of month)
 */
export function getCurrentPeriodMonth() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
}

/**
 * Generate last N months as period_month values
 */
export function getLastNMonths(n = 12) {
  const months = [];
  const now = new Date();

  for (let i = 0; i < n; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const month = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
    months.push(month);
  }

  return months;
}
